import { TextInput } from 'flowbite-react';
import { FC, InputHTMLAttributes } from 'react';

interface EditTextInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label: string;
  onChange: (value: string) => void;
}

export const EditTextInput: FC<EditTextInputProps> = ({
  label,
  onChange,
  ...inputProps
}) => (
  <div className="mb-4">
    <label className="block text-sm font-bold text-gray-700 dark:text-gray-100">
      {label}
    </label>
    <TextInput
      {...inputProps}
      required
      onChange={(e) => onChange(e.target.value)}
      className={`mt-1 block w-full ${inputProps.className || ''}`}
    />
  </div>
);
